<div class="container">
  <div class="message-container" *ngIf="message">
    <span>
      {{ message }}
    </span>
  </div>
  <div class="actions-container">
    <button class="cancel-button" mat-raised-button (click)="clickCanel()">
      {{ cancelLabel }}
    </button>
    <button class="accept-button" mat-raised-button color="primary" (click)="clickAccept()">
      {{ okLabel }}
    </button>
  </div>
</div>